import React from 'react';

import {
  ACCESS_CPANEL_ARTICLE, ADD_DOMAIN_TO_HOST_ARTICLE, CLIENT_AREA_FEATURES_ARTICLE, CONFIGURE_DOMAIN_DNS_ARTICLE, CREATE_WORDPRESS_SITE_ARTICLE,
} from '@/config/urls/supportUrls';

export default {
  diagnostic: {
    helpLinks: [
      {
        title: 'Guia de início da sua hospedagem',
        link: CLIENT_AREA_FEATURES_ARTICLE,
      },
      {
        title: 'Como configurar o domínio (Alterar DNS)',
        link: CONFIGURE_DOMAIN_DNS_ARTICLE,
      },
      {
        title: 'Como adicionar um domínio na hospedagem',
        link: ADD_DOMAIN_TO_HOST_ARTICLE,
      },
      {
        title: 'Como criar um site em WordPress pelo Portal',
        link: CREATE_WORDPRESS_SITE_ARTICLE,
      },
      {
        title: 'Como acessar o cPanel',
        link: ACCESS_CPANEL_ARTICLE,
      },
    ],
  },
  zopimDepartments: {
    builder: 'hgbr_chat_construtor_de_sites',
    domain: 'hgbr_chat_dominios',
    financial: 'hgbr_chat_financeiro',
    mail: 'hgbr_chat_email',
    priority: 'priority',
    retention: 'hgbr_chat_retencao',
    shared: 'hgbr_chat_compartilhado',
    skilled: 'specialized',
    tos: 'hgbr_chat_abuse_tos',
  },
  resetMessages: ['Vou encerrar essa conversa por agora, mas a gente está sempre por aqui se precisar de mais alguma coisa. Em breve, você vai receber um e-mail com o histórico da nossa conversa'],
  chatFinished: 'Essa conversa foi finalizada. Se ainda precisar de ajuda, basta iniciar uma nova conversa.',
  startNewChat: 'Iniciar novo atendimento',
  chatbot: {
    title: (
      <>
        <strong>Olá, sou o Cortex,</strong>
        <br />
        seu especialista virtual.
      </>
    ),
    description: (
      <>
        Estou
        {' '}
        <strong>disponível 24h,</strong>
        {' '}
        e posso te ajudar com:
      </>
    ),
    cards: [
      {
        id: 1,
        cardText: (
          <>
            Dúvidas sobre assinaturas e
            <br />
            os produtos da HostGator.
          </>
        ),
      },
      {
        id: 2,
        cardText: (
          <>
            Resolução de problemas na sua
            <br />
            hospedagem, sites e e-mails.
          </>
        ),
      },
      {
        id: 3,
        cardText: (
          <>
            Assistência com configurações
            <br />
            e status dos seus sites.
          </>
        ),
      },
    ],
    startChat: 'Iniciar conversa',
    aiAlert: 'Conteúdos gerados por inteligência artificial podem conter erros ou serem imprecisos.',
    inputPlaceholder: 'Insira aqui a sua dúvida',
    welcomeMessage: 'Olá, 👋 Sou o especialista virtual da HostGator e estou aqui para te auxiliar.',
    closeChat: 'Deseja encerrar o chat?',
    closeChatAlert: 'Após encerrado, o histórico dessa conversa será apagado.',
    cancel: 'Cancelar',
    finishChat: 'Encerrar chat',
    resetChat: 'Reiniciar chat',
    finishChatTooltip: 'Fechar chat',
    errorMessage: 'Algo deu errado e não foi possível processar sua solicitação. Que tal tentar de novo?',
    errorMessageAgain: 'Ops, parece que o erro continua. Você pode tentar de novo ou falar com um atendente.',
    tryAgain: 'Tentar de novo',
    talkWithHuman: 'Falar com atendente',
    transferToHuman: 'Ok, vou te transferir para um atendente para que ele possa te ajudar, aguarde um momento...',
    notHelpedMe: 'A resposta não me ajudou',
    helpedMe: 'A resposta me ajudou',
    stopMessage: 'Parar resposta do Cortex',
  },
};
